import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const LegalPage = ({ doc }) => {
  return (
    <div data-testid="legal-page-root" style={{ background: "#081412", minHeight: "100vh" }}>
      <Header />
      <main style={{ maxWidth: 760, margin: "0 auto", padding: "160px 24px 120px" }}>
        <h1
          style={{
            fontFamily: "Montserrat, sans-serif",
            fontWeight: 300,
            fontSize: "clamp(32px, 5vw, 48px)",
            letterSpacing: "-0.025em",
            color: "#FFFFFF",
            margin: "0 0 10px",
          }}
        >
          {doc.title}
        </h1>

        <p
          style={{
            fontFamily: "Montserrat, sans-serif",
            fontSize: 13,
            fontWeight: 400,
            color: "rgba(255,255,255,0.45)",
            margin: "0 0 28px",
          }}
        >
          Last updated {doc.updated}
        </p>

        <p
          style={{
            fontFamily: "system-ui, -apple-system, sans-serif",
            fontSize: 17,
            fontWeight: 300,
            lineHeight: 1.7,
            color: "rgba(255,255,255,0.72)",
            margin: "0 0 40px",
          }}
        >
          {doc.intro}
        </p>

        {doc.sections.map((section) => (
          <section key={section.heading} style={{ marginBottom: 36 }}>
            <h2
              style={{
                fontFamily: "Montserrat, sans-serif",
                fontWeight: 500,
                fontSize: 22,
                letterSpacing: "-0.01em",
                color: "#FFFFFF",
                margin: "0 0 14px",
              }}
            >
              {section.heading}
            </h2>
            {section.body.map((paragraph, i) => (
              <p
                key={i}
                style={{
                  fontFamily: "system-ui, -apple-system, sans-serif",
                  fontSize: 16,
                  fontWeight: 300,
                  lineHeight: 1.7,
                  color: "rgba(255,255,255,0.72)",
                  margin: "0 0 14px",
                }}
              >
                {paragraph}
              </p>
            ))}
          </section>
        ))}
      </main>
      <Footer />
    </div>
  );
};

export default LegalPage;
